/*
 * ParLinx header — stuck-state via sentinel IntersectionObserver, mobile-menu
 * <dialog> open/close with Lenis pause. No dependencies.
 */
(function () {
  function initHeader(root) {
    if (root.dataset.plxInited) return;
    root.dataset.plxInited = "1";

    var sentinel = document.querySelector("[data-plx-header-sentinel]");
    var menu = document.querySelector("[data-plx-mobile-menu]");
    var openBtn = root.querySelector("[data-plx-menu-open]");
    var closeBtn = menu && menu.querySelector("[data-plx-menu-close]");

    // Stuck state: the in-flow spacer scrolls away -> lift the fixed bar.
    if (sentinel && "IntersectionObserver" in window) {
      var io = new IntersectionObserver(
        function (entries) {
          root.classList.toggle("is-stuck", !entries[0].isIntersecting);
        },
        { rootMargin: "-8px 0px 0px 0px" }
      );
      io.observe(sentinel);
    } else {
      root.classList.add("is-stuck");
    }

    function lenisStop() {
      if (window.__plxLenis) window.__plxLenis.stop();
    }
    function lenisStart() {
      if (window.__plxLenis) window.__plxLenis.start();
    }

    // Desktop mega menu: JS owns open/close via .is-open so the panel can
    // LINGER — once highlighted it stays up ~3s after the pointer leaves,
    // and re-entering the group or panel cancels the close. CSS keeps a
    // :focus-within fallback for keyboard/no-JS.
    var NAV_LINGER_MS = 3000;
    function initNavGroup(group) {
      var top = group.querySelector("[data-plx-nav-toplink]");
      // The drawer renders as a sibling of the bar (glass blur needs to live
      // outside the bar's backdrop-filter); pair up via the shared index.
      var mega = root.querySelector(
        '[data-plx-mega="' + group.getAttribute("data-plx-nav-group") + '"]'
      );
      var closeTimer = null;
      function setOpen(open) {
        group.classList.toggle("is-open", open);
        if (mega) mega.classList.toggle("is-open", open);
        if (top) top.setAttribute("aria-expanded", open ? "true" : "false");
      }
      function openNow() {
        clearTimeout(closeTimer);
        setOpen(true);
      }
      function closeAfter(ms) {
        clearTimeout(closeTimer);
        closeTimer = setTimeout(function () { setOpen(false); }, ms);
      }
      function bindHoverFocus(el) {
        el.addEventListener("mouseenter", openNow);
        el.addEventListener("mouseleave", function () { closeAfter(NAV_LINGER_MS); });
        el.addEventListener("focusin", openNow);
        el.addEventListener("focusout", function (e) {
          if (!group.contains(e.relatedTarget) && !(mega && mega.contains(e.relatedTarget))) {
            closeAfter(150);
          }
        });
        el.addEventListener("keydown", function (e) {
          if (e.key === "Escape") {
            if (document.activeElement && el.contains(document.activeElement)) {
              document.activeElement.blur();
            }
            clearTimeout(closeTimer);
            setOpen(false);
          }
        });
      }
      bindHoverFocus(group);
      if (mega) bindHoverFocus(mega);
    }
    var navGroups = root.querySelectorAll("[data-plx-nav-group]");
    for (var g = 0; g < navGroups.length; g++) initNavGroup(navGroups[g]);

    if (menu && openBtn) {
      openBtn.addEventListener("click", function () {
        menu.showModal();
        openBtn.setAttribute("aria-expanded", "true");
        lenisStop();
      });
      if (closeBtn) {
        closeBtn.addEventListener("click", function () {
          menu.close();
        });
      }
      // Close when a menu link is chosen (same-page anchors don't navigate).
      menu.addEventListener("click", function (e) {
        var target = e.target;
        if (target && target.closest("a")) menu.close();
        // Backdrop click: the dialog itself is full-screen, so only close on
        // clicks outside the inner content (none here — Esc covers it).
      });
      menu.addEventListener("close", function () {
        openBtn.setAttribute("aria-expanded", "false");
        lenisStart();
      });
    }
  }

  function initAll() {
    var roots = document.querySelectorAll("[data-plx-header]");
    for (var i = 0; i < roots.length; i++) initHeader(roots[i]);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
  // Shopify theme editor: re-init when the section reloads
  document.addEventListener("shopify:section:load", initAll);
})();
